/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Members_Checked_InInputs */

const en_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Member Checked in`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Members Checked in`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const de_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Mitglied eingecheckt`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Mitglieder eingecheckt`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const es_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} miembro registrado`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} miembros registrados`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const fr_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membre enregistré`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membres enregistrés`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const it_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membro registrato`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membri registrati`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const pt_br2_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membro fez check-in`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membros fizeram check-in`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const pl_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} członek zameldowany`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} członków zameldowanych`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

const hu_admin_dashboard_members_checked_in = /** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} tag bejelentkezett`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} tag bejelentkezett`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_checked_in");
};

/** @type {(inputs: Admin_Dashboard_Members_Checked_InInputs) => LocalizedString} */
const ro_admin_dashboard_members_checked_in = en_admin_dashboard_members_checked_in;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} Member Checked in" |
* | "other" | "{count} Members Checked in" |
*
* @param {Admin_Dashboard_Members_Checked_InInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_members_checked_in = /** @type {((inputs: Admin_Dashboard_Members_Checked_InInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Members_Checked_InInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_members_checked_in(inputs)
	if (locale === "de") return de_admin_dashboard_members_checked_in(inputs)
	if (locale === "es") return es_admin_dashboard_members_checked_in(inputs)
	if (locale === "fr") return fr_admin_dashboard_members_checked_in(inputs)
	if (locale === "it") return it_admin_dashboard_members_checked_in(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_members_checked_in(inputs)
	if (locale === "pl") return pl_admin_dashboard_members_checked_in(inputs)
	if (locale === "hu") return hu_admin_dashboard_members_checked_in(inputs)
	return ro_admin_dashboard_members_checked_in(inputs)
});
export { admin_dashboard_members_checked_in as "admin.dashboard.members_checked_in" }